import { useDispatch } from 'app-redux'
import { useCallback, useEffect } from 'react'
import { presenterActions } from './redux'
import { readSavedSpeakers, saveSpeakers } from './speakers-storage'

/**
 * The trainer's speakers for the running presentation, in the store
 * (`presenter.speakers`) so the presentation window follows. A presentation
 * starts on the speakers this browser last used and, when it ends, the
 * recordings go back to the system default. Returns how to choose: the
 * choice is kept for the next presentation.
 *
 * Mounted around the whole session route with the console: a break moves the
 * trainer to another room, and the choice must stay.
 */
export const useSpeakerChoice = (
	presentation: string | undefined
): ((deviceId: string | null) => void) => {
	const dispatch = useDispatch()

	useEffect(() => {
		if (!presentation) {
			return
		}
		dispatch(presenterActions.speakersChosen(readSavedSpeakers()))
		return () => {
			dispatch(presenterActions.speakersChosen(null))
		}
	}, [dispatch, presentation])

	return useCallback(
		(deviceId: string | null): void => {
			saveSpeakers(deviceId)
			dispatch(presenterActions.speakersChosen(deviceId))
		},
		[dispatch]
	)
}
